<div class="tracking-details mb-12" *ngIf="transportJourneys?.portToPort; let p">
  <h3>{{'common.tracking_details_txt' | translate}}</h3>
  <div class="row">
    <div class="col">
      <label class="label">{{'common.origin_txt' | translate}}</label>
      <span class="pl-4 text-bold">{{ p.originPort || 'N/A' }}</span>
    </div>

    <div class="col">
      <label class="label">{{'shipments.air_shipments.origin_airport_txt' | translate}}</label>
      <span class="pl-4 text-bold">{{ p.originPortId || 'N/A' }}</span>
    </div>

    <div class="col">
      <label class="label">{{'shipments.air_shipments.destination_airport_txt' | translate}}</label>
      <span class="pl-4 text-bold">{{ p.destinationPortId || 'N/A' }}</span>
    </div>

    <div class="col">
      <label class="label">{{'common.destination_txt' | translate}}</label>
      <span class="pl-4 text-bold">{{ p.destinationPort || 'N/A'}}</span>
    </div>
  </div>

  <div class="mt-20 tracking-details">
    <div class="row">
      <div class="col-9">
        <label class="label inline-block">{{'common.origin_txt' | translate}} {{p.portAtd ? 'ATD' : 'ETD'}}</label>
        <span class="pl-4 text-bold">{{ p.portAtd || p.portEtd }}</span>
      </div>

      <div class="col-3">
        <label class="label inline-block">{{'common.flight_atd_txt' | translate}}</label>
        <span class="pl-4 text-bold">{{ p.hubAtd }}</span>
      </div>
    </div>

    <div class="row">
      <div class="col-9">
        <label class="label inline-block">{{'common.flight_ata_txt' | translate}}</label>
        <span class="pl-4 text-bold">{{ p.hubAta }}</span>
      </div>

      <div class="col-3">
        <label class="label inline-block">{{'common.destination_txt' | translate}} {{p.portAta ? 'ATA' : 'ETA'}}</label>
        <span class="pl-4 text-bold">{{ p.portAta || p.portEta }}</span>
      </div>
    </div>
  </div>
</div>